module.exports = __webpack_public_path__ + "img/world2.db02465f.png";